module.exports = __webpack_public_path__ + "static/media/baterias.c49e8684.png";